import {useEffect, useState} from 'react';
import {Modal, Button, Group, Badge} from '@mantine/core';
import { Table } from '@mantine/core';
import {collection, query} from "firebase/firestore";
import {firestore} from "../../firebase";
import {useFirestoreQueryData} from "@react-query-firebase/firestore";
import {useClipboard, useScrollLock} from "@mantine/hooks";
export default function PlannerModal(
    {onClose, board, subdomain}
) {

    const [scrollLocked, setScrollLocked] = useScrollLock();

    useEffect(() => {
        setScrollLocked(true);
        return () => setScrollLocked(false);
    }, [])
    const rsvpRef = collection(firestore, `boards/${board}/rsvp`);
    const data = useFirestoreQueryData(['rsvp', board], query(rsvpRef));

    const clipboard = useClipboard({ timeout: 1000 });

    const rows = data?.data?.map((entry, index) => (<tr key={index}>
        <td>{entry.name}</td>
        <td>{entry.people}</td>
        <td>{entry.status === "confirmat" ? <Badge color="green">Confirmat</Badge> : <Badge color="red">Refuzat</Badge>}</td>
    </tr>))

    const exporta = () => {
        let tempData = [["Nume", "Persoane", "Raspuns"]];
        data?.data?.forEach((entry) => tempData.push([entry.name, entry.people, entry.status]));
        exportToCsv(subdomain, tempData);
    }


    return (
        <Modal
            fullScreen={true}
            withinPortal={true}
            opened={true}
            overlayOpacity={1}
            zIndex={999999}
            onClose={() => onClose()}
            title="Lista invitati"
        >

           <Table>
               <thead>
                   <tr>
                       <th>Nume</th>
                       <th>Persoane</th>
                       <th>Raspuns</th>
                   </tr>
               </thead>
               <tbody>
                 {rows}
               </tbody>
           </Table>
            <Group mt={'md'}>
                <Button onClick={() => exporta()}>Exporta</Button>
                <Button onClick={() => clipboard.copy(`https://picboard.ro/${subdomain}?rsvp=1`)}>Copiaza link</Button>
            </Group>
        </Modal>
    );
}


function exportToCsv(filename, rows) {
    var processRow = function (row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
            var innerValue = row[j] === null ? '' : row[j].toString();
            if (row[j] instanceof Date) {
                innerValue = row[j].toLocaleString();
            };
            var result = innerValue.replace(/"/g, '""');
            if (result.search(/("|,|\n)/g) >= 0)
                result = '"' + result + '"';
            if (j > 0)
                finalVal += ',';
            finalVal += result;
        }
        return finalVal + '\n';
    };

    var csvFile = '';
    for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
    }

    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}